var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHospitalinfoAftercare = function SvgHospitalinfoAftercare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BCBCBC",
    d: "M16.91 20a2.5 2.5 0 0 1-2.45 2h-5.5v-1h5.5c.65 0 1.21-.42 1.41-1 .06-.16.09-.32.09-.5 0-.83-.67-1.5-1.5-1.5h-5.5l-4 1v6h15l6.52-5.42a1.099 1.099 0 0 0-1.05-1.92L19.96 20z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6726",
    d: "M21.57 7.53s-4.75-1.56-7.21.16c-1.96 1.37-2.47 3.45-.98 5.57s3.61 2.36 5.57.98c2.46-1.71 2.62-6.71 2.62-6.71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    d: "M9.96 14.37v-.75c1.37 0 3.03-.54 4.22-1.37l3.08-2.16.43.61-3.08 2.16c-1.31.92-3.13 1.51-4.65 1.51"
  })));
};
export default SvgHospitalinfoAftercare;